import styled from 'styled-components';
import Image from '../../utils/Image/Image';
import { Text14Bold, Text16Regular, Text20Bold } from '../../utils/Text/Text.styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 74rem;

  @media only screen and (max-width: 500px) {
    width: 100%;
  }
`;

export const ContainerContent = styled.div`
  display: flex;
`;

export const FilterContainer = styled.div`
  display: flex;
  padding: 1.2rem 0.8rem;
  gap: 0.8rem;
`;

export const FilterButton = styled.div`
  border-radius: 10px;
  background: #badaf7;
  color: ${({ $selected }) => ($selected ? '#000' : '#3e9be4')};
  font-size: 1.5rem;
  font-weight: 400;
  letter-spacing: -0.15px;
  padding: 1rem 1.4rem;
  min-width: fit-content;
  cursor: pointer;
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50rem;
`;

export const InfiniteScrollMarker = styled.div`
  min-height: 1rem;
`;

export const LoaderMoreContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 24rem;
  gap: 0.3rem;
  flex-grow: 1;
  padding-left: 0.8rem;
  padding-right: 1.2rem;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 55rem;
  overflow: auto;
`;

export const LeftContentScroll = styled.div`
  display: flex;
  flex-direction: column;
  height: 55rem;
  overflow: auto;
`;

export const MediaWrapper = styled.div`
  border-radius: 8px;
  overflow: hidden;
  height: 24rem;
  position: relative;
`;

export const StyledImage = styled(Image)`
  height: 100%;
  cursor: pointer;

  img {
    object-fit: cover;
  }
`;

export const PlayIconWrapper = styled.div`
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  /* background: rgba(0, 0, 0, 0.56); */
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const SelectIconWrapper = styled.div`
  position: absolute;
  top: 0.4rem;
  right: 0.4rem;
  z-index: 1000;
  height: 3rem;
  width: 3rem;
  background-color: #00000060;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Footer = styled.div`
  padding: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #f3f4f6;
`;

export const CloseButton = styled.button`
  border-radius: 16px;
  background: #f5f5f5;
  width: 17rem;
  height: 4.6rem;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ba1619;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.42px;
`;

export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;

  p {
    white-space: nowrap;
  }
`;

export const UnselectText = styled(Text14Bold)`
  letter-spacing: -0.42px;
  text-decoration-line: underline;
  color: #1672ba;
  cursor: pointer;
`;

export const NotValidMedia = styled.div`
  position: absolute;
  background: rgba(0, 0, 0, 0.76);
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    color: #fff;
    text-align: center;
  }
`;

export const SoldMedia = styled.div`
  background: ${({ $free }) => ($free ? '#003b6a' : '#E43E41')};
  height: 1.9rem;
  position: absolute;
  transform: rotate(-33.477deg);
  z-index: 10000;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: -0.12px;
  width: 11rem;
  display: flex;
  align-items: center;
  justify-content: center;
  left: -3rem;
  top: 1rem;
`;

export const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 27rem;
  max-width: 27rem;
  border-right: 1px solid #f3f4f6;
`;

export const Title = styled(Text20Bold)`
  margin-left: 1.6rem;
  margin-bottom: 2.4rem;
  margin-top: 1.4rem;
`;

export const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ListItem = styled.div`
  padding: 1.6rem 1.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f3f4f6;
  gap: 0.4rem;
  cursor: pointer;
  background: ${({ $selected }) => ($selected ? '#EEF5FD' : 'transparent')};
`;

export const ListItemRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
`;

export const ListItemColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

export const MediaCountRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const MediaCountText = styled(Text16Regular)`
  color: #6c737f;
`;

export const ListContainerV2 = styled.div`
  display: flex;
  flex-direction: column;
`;
